<button type="button" class="btn btn-secondary btn-prepend-icon  btn-horizontal btn-horizontal-margin" (click)="btnClick()">
  <span class="loading-spinner" role="status"></span>
  <span class="button-text">{{text}}</span>
</button>
